<template>
    <div class="w-100 text-center loader-container" :class="{'overlay': true}" v-show="busy">
        <div>
            <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </div>
    </div>
</template>

<script setup>
    import { useStore } from 'vuex';
    import { computed, watch } from 'vue';

    const store = useStore()
    const busy = computed(() => store.getters.busy)
</script>

<style scoped>
    .loader-container.overlay {
        z-index: 1000000;
    }
</style>
